import { useNavigate } from "react-router-dom";

import { Button } from "@/components/ui/Button";
import { Icon } from "@/components/layout/Icon";

/** Where Check In / Check Out live on the dashboard. */
export const TODAY_CARD_ID = "ess-today";

function scrollToToday() {
  const el = document.getElementById(TODAY_CARD_ID);
  if (!el) return;
  const reduce = window.matchMedia?.("(prefers-reduced-motion: reduce)").matches;
  el.scrollIntoView({ behavior: reduce ? "auto" : "smooth", block: "start" });
}

/** The few things an employee does most. Each one is shown only when the
 * employee's company has the module and the employee may use it. */
export function QuickActions({ checkIn, attendance, payslip }: { checkIn: boolean; attendance: boolean; payslip: boolean }) {
  const navigate = useNavigate();
  if (!checkIn && !attendance && !payslip) return null;
  return (
    <div className="flex flex-wrap gap-2" data-testid="quick-actions" aria-label="Quick actions" role="group">
      {checkIn && (
        <Button size="sm" onClick={scrollToToday}>
          <Icon name="fingerprint" className="h-4 w-4" />
          Check in / out
        </Button>
      )}
      {attendance && (
        <Button size="sm" variant="outline" onClick={() => navigate("/my-attendance")}>
          <Icon name="calendar-check" className="h-4 w-4" />
          My attendance
        </Button>
      )}
      {payslip && (
        <Button size="sm" variant="outline" onClick={() => navigate("/my-payslips")}>
          <Icon name="wallet" className="h-4 w-4" />
          My payslip
        </Button>
      )}
    </div>
  );
}
